// extracted by mini-css-extract-plugin
export default {"footer":"bNcMS0yPvTaZp3QstVhA"};